import { ITooltipHostProps, TooltipHost as FabricTooltipHost } from "@fluentui/react";

export type TooltipHostProps = ITooltipHostProps;

export const TooltipHost = FabricTooltipHost;
